var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-733 -251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 4,
    transform: "translate(733 251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbb00",
    d: "M743.063 269.228l-.742 2.771-2.713.057a10.682 10.682 0 01-.079-9.957l2.416.443 1.058 2.4a6.364 6.364 0 00.06 4.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518ef8",
    d: "M759.477 265.008a10.659 10.659 0 01-3.8 10.307l-3.042-.155-.431-2.688a6.355 6.355 0 002.734-3.245h-5.7v-4.218h10.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28b446",
    d: "M755.675 275.316a10.667 10.667 0 01-16.068-3.262l3.456-2.829a6.342 6.342 0 009.139 3.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f14336",
    d: "M755.805 258.792l-3.453 2.828a6.341 6.341 0 00-9.347 3.317l-3.475-2.841a10.665 10.665 0 0116.275-3.304z"
  }))));
}

export default SvgGoogleLogo;